import React from 'react';
import './style/admin.css';
import { useSearchParams } from 'react-router-dom';
import { useLanguage } from './../i18n/LanguageContext';
import AuthSocialForm from '../components/AuthSocialForm';
import logoImage from './../img/rp_swiss_small.png'; // Cleanly importing the relative image asset

export default function Authentication() {
  // 1. Initialize the search params hook
  const [searchParams] = useSearchParams();
  const { strings } = useLanguage();

  // 2. Extract the 'error' key from the query string (returns null if absent)
  const errorMessage = searchParams.get('error');

  return (
    <div>
    <table className="auth-table"><tbody><tr><td>
          <h1 className="auth-title">{strings.auth.admin_title}</h1>
          </td><td>
          <img 
            src={logoImage} 
            alt="RPSwiss Logo" 
            className="auth-logo" 
          />
      </td></tr>
      <tr><td colSpan="2">
        <AuthSocialForm error={errorMessage} />
        </td></tr></tbody></table>
    </div>
  );
}